import { useId } from 'react';

/**
 * XMarkAnimatedIcon — Ícone de X (fechar/limpar) animado padrão do Joshua.
 *
 * Uso: envolva com um elemento que tenha a classe `xmark-animated`
 * para ativar a animação no hover (linhas cruzam com rotação + pop).
 *
 * Exemplo:
 *   <button className="btn-add xmark-animated" onClick={onClear}>
 *     <XMarkAnimatedIcon size={15} />
 *     <span className="btn-text">Limpar</span>
 *   </button>
 */
export default function XMarkAnimatedIcon({ size = 15, startColor = '#d1d5db', endColor = '#9ca3af' }) {
  const id = useId();
  const gid = `xmarkG${id}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <defs>
        <linearGradient id={gid} gradientUnits="userSpaceOnUse" x1="6" y1="6" x2="18" y2="18">
          <stop offset="0%" stopColor={startColor} />
          <stop offset="100%" stopColor={endColor} />
        </linearGradient>
      </defs>
      <g className="xmark-line1" stroke={`url(#${gid})`}>
        <path d="M18 6 6 18"/>
      </g>
      <g className="xmark-line2" stroke={`url(#${gid})`}>
        <path d="m6 6 12 12"/>
      </g>
    </svg>
  );
}
